import type { IconProps } from '@tabler/icons-react'
import type { IconHome2 } from '@tabler/icons-react'

export const IconRedeem: typeof IconHome2 = (({
  size = 24,
  stroke = 2,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="3.7" cy="12" r="2.8" fill="none" />
    <circle cx="20.3" cy="12" r="2.5" fill="currentColor" />
    <polygon points="9,9 15,12 9,15" fill="currentColor" stroke="none" />
  </svg>
)) as typeof IconHome2
